// extracted by mini-css-extract-plugin
export default {"wrapper":"SourceFilePage_wrapper__84Ze5"};